/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 */
import React from 'react';
import {Trans} from "react-i18next";
import CopyBuildingLinkApp from "../Functionality/CopyBuildingLinkApp";
import CustomModal from "../../../components/Modal/CustomModal";
import CustomWarningLegend from "../../../components/CustomWarningLegend";

/**
 * Registration link of a building, or of one of its users when userSelected is
 * received, in that case the legend names the user and the link points at them.
 *
 * @param {Object} props
 * @param {boolean} props.show - Shows the modal.
 * @param {Function} props.setShow - Closes the modal.
 * @param {Object} [props.itemSelected] - Building the generic registration link belongs to.
 * @param {Object} [props.userSelected] - User the link is generated for, with userId, name, apartment and buildingApartmentId.
 * @param {Function} [props.setItemSelected] - Clears the selected item when the modal closes.
 * @param {Function} [props.setSelectedList] - Clears the selected list when the modal closes.
 */
const CopyBuildingLinkModal = ({
    show,
    setShow,
    itemSelected,
    userSelected,
    setItemSelected,
    setSelectedList
}) => {
    const {
        t,
        buttonText,
        handleConfirm,
        link,
        onHideModal
    } = CopyBuildingLinkApp({
        itemSelected,
        userSelected,
        setShow,
        setItemSelected,
        setSelectedList
    });


    return (<CustomModal
                show={show}
                title={"registration_link"}
                size="lg"
                cancelButton={false}
                closeButton={false}
                confirmButton={true}
                disabled={false}
                onConfirm={handleConfirm}
                buttonConfirm={buttonText}
                onHide={onHideModal}
                classNameBody="pt-2"
            >
                <div className={"row"}>
                    <div className={"col-12 center-text"}>
                        {userSelected ? (
                            <p className={"font-color-general-950 fs-14px"}>
                                <Trans
                                    i18nKey={"share_this_secure_link_with_x_so_they_can_verify_their_identity"}
                                    values={{ name: userSelected?.name }}
                                    components={{ bold: <strong /> }}
                                />
                            </p>
                        ) : (
                            <>
                                <p className={"font-color-general-950 fs-14px"}>{t("this_unique_link_gives_users_direct_access_to_the_building_registration_flow")}</p>
                                <p className={"font-color-general-950 fs-14px"}>{t("by_opening_it_residents_can_complete_their_registration")}</p>
                            </>
                        )}
                    </div>

                    <div className={"col-12 center-text"}>
                        <p className={"font-color-general-950 ibl-font-w-600 text-uppercase fs-14px"}>{t("warning")}: {t("it_must_not_be_shared_with_unauthorized_individuals")}</p>
                    </div>
                    <div className={"col-12 center-text"}>
                        <p className={"font-color-general-950 ibl-font-w-600 text-uppercase fs-14px"}>{t("please_copy_the_registration_link_to_continue")}</p>
                    </div>
                    <div className={"col-12"}>
                        <CustomWarningLegend>{link}</CustomWarningLegend>
                    </div>
                </div>
            </CustomModal>
    );
};

export default CopyBuildingLinkModal;
